namespace $.$$ {
	export class $shm_hitalama_benchmarks_page_metrics_delete extends $.$shm_hitalama_benchmarks_page_metrics_delete {
		@ $mol_action confirm(event?: Event | null) {
			if (!event) return null
			this.remove(event)
			this.showed(false)
			return event
		}
		@ $mol_action cancel(event?: Event | null) {
			if (event) this.showed(false)
			return event ?? null
		}
	}
}
